import React from "react";
import DataTablesApprovers from "./DataTablesApprovers";

const Approvers = (props) => {


    return (
        <>
            <div className="col-lg-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Approvers</h2>
                        {/* <a className="header-dropdown dropdown dropdown-animated scale-left"><i className="fa fa-pencil mr-2"></i>Edit Shourtcuts</a> */}
                    </div>
                    <div className="body text-center card-body-shadow">
                        <DataTablesApprovers data={props?.approver} />
                    </div>
                </div>
            </div>

        </>
    );
}
export default Approvers;